export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";

export const loginSuccess = (payload) => ({
  type: LOGIN_SUCCESS,
  payload,
});

export const logout = () => {
  localStorage.removeItem("accessToken");

  return {
    type: LOGOUT,
  };
};